module.exports = __webpack_public_path__ + "static/t5-38b784e54c3836ca6165bace9279402e.png";